export default __webpack_public_path__ + "static/media/contracts.7b7f3eb3.svg";